import React  from 'react';

const Enclosure66 = () => 
    <div
        style={{
            WebkitTouchCallout:'none',  /*系统默认菜单被禁用*/
            MozUserSelect: 'none',  /*火狐*/
            WebkitUserSelect: 'none',  /*webkit浏览器*/
            msUserSelect: 'none',  /*IE10*/
            khtmlUserSelect: 'none',  /*早期浏览器*/
            userSelect: 'none',
        }}
     >
        <div style={{ textIndent: '2em' }}>
            <h3>一、电商中心副总监岗位职责：</h3>
            <p>1、对部门总监负责，坚决服从并执行其工作指令；完成既定工作目标；</p>
            <p>2、根据电商中心目标，协助部门总监制定可行性盈利方案；</p>
            <p>3、调配部门人员，完成网络营销事业部相关工作，达成既定目标；实现盈利；</p>
            <p>4、负责集团公司所有pc端、移动端项目的运营的相关工作；</p>
            <p>5、根据网络营销事业部需求，分析报表、制定可行性营销、推广方案；</p>
            <p>6、与各管理公司对接需求情况，并提出自己方案并报告部门经理；</p>
            <p>7、密切关注部门内部各种情况的动向做到提前预判并解决，发现问题及时处理上报；</p>
            <p>8、密切关注其他机构项目营销模式，并把好的方法加以借鉴和应用；</p>
            <p>9、遵守公司各项规章制度、保密协议，遵守各项作息时间，保证办公环境及宿舍安全与卫生等各项指标的合格率；</p>
            <p>10、完成集团公司ERP测试及培训工作；对集团内部系统的维护、管理工作；</p>
            <br/>
            <h3>孵化项目部副总监岗位职责：</h3>
            <p>1、对部门经理负责，坚决服从并执行其工作指令；完成既定工作目标；</p>
            <p>2、根据电商中心目标，协助部门经理制定可行性盈利方案；</p>
            <p>3、调配部门人员，完成云豪大数据平台相关工作，达成既定目标；实现盈利；</p>
            <p>4、负责集团公司所有pc端、移动端项目的开发、建设、维护、备份工作；并保证所开发项目具有可持续开发及技术可遗传性；</p>
            <p>5、了解掌握相关技术语言编程和开发环境；</p>
            <p>6、完成网络营销管理公司组织的技术内训和外部培训；</p>
            <p>7、根据产品设计要求，完成各类开发文档的编制工作；</p>
            <p>8、与外援团队的对接时时进度情况，并提出自己要求并报告部门经理；</p>
            <p>9、密切关注部门内部各种情况的动向做到提前预判并解决，发现问题及时处理上报</p>
            <p>10、密切关注其他机构项目开发模式，并把好的方法加以借鉴和应用；</p>
            <p>11、遵守公司各项规章制度、保密协议，遵守各项作息时间，保证办公环境及宿舍安全与卫生等各项指标的合格率；</p>
            <br/>
            <h3>短期项目负责人岗位职责：</h3>
            <p>1、服从孵化项目部副总监的工作安排，完成既定工作目标；</p>
            <p>2、根据电商中心目标，协助部门经理制定可行性盈利方案；</p>
            <p>3、调配开发人员，完成云豪大数据平台及其他项目的开发工作达成既定目标；</p>
            <p>4、负责集团公司所有pc端、移动端项目的开发、建设、维护、备份工作；并保证所开发项目具有可持续开发及技术可遗传性；</p>
            <p>5、熟练掌握Java语言编程和开发环境，熟悉SpingBoot+MyBatis框架技术，精通MySql数据库，能够和团队进行良好技术沟通与交流。</p>
            <p>6、参与小组范围内产品技术讨论例会，根据集团产品详细设计说明书进行产品研发以及集团商业流程编排定制等任务，及时提出对研发产品的完善性建议。</p>
            <p>7、与外援团队的对接时时进度情况，并提出自己要求并报告负责人；</p>
            <p>8、密切关注项目开发各种情况的动向做到提前预判并解决，发现问题及时处理上报</p>
            <p>9、密切关注其他机构项目开发模式，并把好的方法加以借鉴和应用；</p>
            <p>10、遵守公司各项规章制度、保密协议，遵守各项作息时间，保证办公环境及宿舍安全与卫生等各项指标的合格率；</p>
            <br/>
            <h3>后台开发岗位职责：</h3>
            <p>1、服从孵化项目部副总监及上级领导的工作安排，完成既定工作目标；</p>
            <p>2、根据电商中心目标，协助部门经理制定可行性盈利方案；</p>
            <p>3、配合孵化项目部，完成云豪大数据平台及其他项目的开发工作达成既定目标；</p>
            <p>4、熟练掌握Java语言编程和开发环境，熟悉SpingBoot+MyBatis框架技术，精通MySql数据库应用技术，能够和团队进行良好技术沟通与交流。</p>
            <p>5、参与小组范围内产品技术讨论例会，根据集团产品详细设计说明书进行产品研发以及集团商业流程编排定制等任务，及时提出对研发产品的完善性建议。</p>
            <p>6、密切关注项目开发各种情况的动向做到提前预判并解决，发现问题及时处理上报,密切关注其他机构项目开发模式，并把好的方法加以借鉴和应用；</p>
            <p>7、遵守公司各项规章制度、保密协议，遵守各项作息时间，保证办公环境及宿舍安全与卫生等各项指标的合格率；</p>
            <br/>
            <h3>前端开发人员岗位职责：</h3>
            <p>1、服从孵化项目部副总监及上级领导的工作安排，完成既定工作目标；</p>
            <p>2、根据电商中心目标，协助部门经理制定可行性盈利方案；</p>
            <p>3、根据孵化项目部需求，完成云豪大数据平台及其他项目的开发工作达成既定目标；</p>
            <p>4、熟练掌握Jsx语言编程和开发环境，熟悉react框架技术，能够与后台接口完成对接。</p>
            <p>5、参与小组范围内产品技术讨论例会，根据集团产品详细设计说明书进行产品研发以及集团商业流程编排定制等任务，及时提出对研发产品的完善性建议。</p>
            <p>6、密切关注项目开发各种情况的动向做到提前预判并解决，发现问题及时处理上报</p>
            <p>7、密切关注其他机构项目开发模式，并把好的方法加以借鉴和应用；</p>
            <p>8、遵守公司各项规章制度、保密协议，遵守各项作息时间，保证办公环境及宿舍安全与卫生等各项指标的合格率；</p>
            <br/>
            <h3>推广人员岗位职责：</h3>
            <p>1、服从上级领导的工作安排，完成既定工作目标；对部门经理负责；</p>
            <p>2、根据电商中心目标，协助部门经理制定可行性盈利方案；</p>
            <p>3、配合推广负责人，完成营销客户管理系统及相关工作，达成既定目标；</p>
            <p>4、关注推广各种情况的动向做到提前预判并解决，发现问题及时处理上报；密切关注竞争对手的网站，把好的方法加以借鉴和应用；</p>
            <p>5、配合上级领导完成客服工作。</p>
            <p>6、负责网站站内、站外SEO运营；负责网站与技术部门沟通、修改、建设、备份、反馈等工作；</p>
            <p>7、熟悉卡车相关业务操作流程及相关资料的收集整理</p>
            <p>8、配合上级领导完成绩效数据统计</p>
            <p>9、遵守公司各项规章制度，遵守各项作息时间，保证办公环境及宿舍安全与卫生等各项指标的合格率；</p>
            <br/>
            <h3>微商城岗位职责：</h3>
            <p>服从上级领导的工作安排，完成既定工作目标；对部门经理负责；</p>
            <p>根据电商中心目标，协助部门经理制定可行性盈利方案；</p>
            <p>配合推广负责人，完成营销客户管理系统及相关工作，达成既定目标；</p>
            <p>关注推广各种情况的动向做到提前预判并解决，发现问题及时处理上报；密切关注竞争对手的网站，把好的方法加以借鉴和应用；</p>
            <p>完成移动商城相关工作；配合各部门完成微商城、促销活动等相关工作；</p>
            <p>完成绩效考核数据、分析数据的相关统计工作；</p>
            <p>负责网站移动端SEO运营；负责网站与技术部门沟通、修改、建设、备份、反馈等工作；</p>
            <p>熟悉移动端相关业务操作流程及相关资料的收集整理</p>
            <p>遵守公司各项规章制度，遵守各项作息时间，保证办公环境及宿舍安全与卫生等各项指标的合格率；</p>
            <br/><br/>
        </div>
    </div>


export default Enclosure66;